import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ReportDetailsModel, TableColumn, ReportTableType, TableRowEvent } from '@models/index';
import { ButtonComponent } from '@components/index';
import { LoadingStateService, TableColumnsService } from '@services/index';
import { MatTooltipModule } from '@angular/material/tooltip';


@Component({
  selector: 'app-table',
  standalone: true,
  imports: [
    CommonModule,
    ButtonComponent,
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule
  ],
  providers: [DatePipe],
  templateUrl: './table.component.html',
  styleUrl: './table.component.scss',
})
export class TableComponent implements OnInit {
  public displayedColumns: Array<string> = [];
  public tableHeadersData: Array<TableColumn> = [];
  public loading$ = this.loadingStateService.loading$

  @Input() dataSet: ReportDetailsModel[] | null = [];
  @Input() tableType: ReportTableType | string = ReportTableType.PICKUP;
  @Output() tableRowEvent = new EventEmitter<TableRowEvent>();

  public newDate:number = (new Date()).getTime();

  constructor(
    private tableColumnsService: TableColumnsService,
    private loadingStateService: LoadingStateService
  ) {}


  ngOnInit(): void {
    this.initializeTableHeaders();
  }

  initializeTableHeaders(): void {
    this.tableHeadersData = this.tableColumnsService.getTableHeaders(ReportTableType[this.tableType]);
    this.displayedColumns = this.tableHeadersData?.map(
      (column) => column.columnDef
    );
  }

  public onButtonEvent(row: ReportDetailsModel, operation: string): void {
    this.tableRowEvent.emit({
      operation,
      row
  });
  }
}
